import { create } from 'zustand';

interface AuthState {
  token: string | null;
  role: string | null;
  userId: number | null;
  name: string | null;
  grade: number | null;
  setAuth: (token: string, role: string, userId: number, name: string, grade?: number) => void;
  logout: () => void;
}

const useAuthStore = create<AuthState>((set) => ({
  token: localStorage.getItem('token'),
  role: localStorage.getItem('role'),
  userId: localStorage.getItem('userId') ? Number(localStorage.getItem('userId')) : null,
  name: localStorage.getItem('name'),
  grade: localStorage.getItem('grade') ? Number(localStorage.getItem('grade')) : null,

  setAuth: (token, role, userId, name, grade) => {
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);
    localStorage.setItem('userId', String(userId));
    localStorage.setItem('name', name);
    if (grade) localStorage.setItem('grade', String(grade));
    set({ token, role, userId, name, grade: grade || null });
  },

  logout: () => {
    localStorage.clear();
    set({ token: null, role: null, userId: null, name: null, grade: null });
  },
}));

export default useAuthStore;
